import React from 'react'
import './benifitstorage.scss'
const Benifitsstorage = () => {
    return (
        <>
            <section className='benifitsprntstorage'>
                <div className="custom-container">
                    <div className="beniftschlprnt">
                        <div className="headerbenifitsss">

                            <h2>Storage With No Limits</h2>
                            <p>Storage scales seamlessly to accommodate your growing data volume.</p>
                        </div>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits">
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Chatandpay\profile.svg" alt="" />
                                <h4>Solo Developers</h4>
                                <p>Securely back up the exact amount of data you need without breaking the bank.</p>
                            </div>
                            <div className="cardonebenifits">
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg2.png" alt="" />
                                </div>
                                <img className='img-fluid' src="\assets\Enterprisessvg.svg" alt="" />

                  
                                <h4>Enterprises</h4>
                                <p>Store large volumes of archival data more securely than ever while significantly reducing costs.</p>
                            </div>
                            <div className="cardonebenifits">
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg3.png" alt="" />
                                </div>
                                    <img className='img-fluid' src="\assets\Crypto Enthusiastssvg.svg" alt="" />

                            
                                <h4>Crypto Enthusiasts</h4>
                                <p>Safeguard your digital assets with tamper-proof storage.</p>
                            </div>
                            <div className="cardonebenifits">
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg4.png" alt="" />
                                </div>
                                    <img className='img-fluid' src="\assets\Content Creatorssvg.svg" alt="" />

                              
                                <h4>Content Creators</h4>
                                <p>Store your media files securely and keep them always accessible.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benifitsstorage